import type { SxProps, Theme } from '@mui/material/styles';

import { menuPaperProps } from './GeneratikTableToolbar.styles';

export const dropdownMenuPaperSx: SxProps<Theme> = {
  ...menuPaperProps.sx,
  minWidth: '11.25rem',
  overflow: 'hidden',
  padding: 0,
};

export const accentCheckIconSx: SxProps<Theme> = {
  fontSize: '0.9375rem',
  color: 'accent.main',
};
